var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid28({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7,12.78V7.06H8.13a4.23,4.23,0,0,1,1.33.15,1.33,1.33,0,0,1,.67.55,1.6,1.6,0,0,1,.25.9A1.56,1.56,0,0,1,10,9.73a1.85,1.85,0,0,1-1.13.53,2.37,2.37,0,0,1,.62.48,6.51,6.51,0,0,1,.66.93l.7,1.11H9.46l-.83-1.24A8.89,8.89,0,0,0,8,10.69a.92.92,0,0,0-.35-.23,1.68,1.68,0,0,0-.58-.07H6.85v2.39Zm1.15-3.3h.86a4.93,4.93,0,0,0,1-.07.65.65,0,0,0,.32-.24.75.75,0,0,0,.12-.43A.7.7,0,0,0,9,8.27.78.78,0,0,0,8.6,8c-.09,0-.38,0-.84,0H6.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid28);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_28.f020c46832538f6cd8351a9ae00fe433.svg";
export { ForwardRef as ReactComponent };